import React, { useState, useEffect, useCallback, useRef } from "react";
import "../../../styles/Part1.css";
import Modal from "react-modal";
import VocabularyStudy from "./VocabularyStudy";
import { professionalQuestions } from "../../../data/part1/professional";
import { workplaceQuestions } from "../../../data/part1/location/workplace";
import { dailyQuestions } from "../../../data/part1/daily";
import { constructionQuestions } from "../../../data/part1/construction";
import { outdoorQuestions } from "../../../data/part1/outdoor";
import { shoppingQuestions } from "../../../data/part1/shopping";
import { trafficQuestions } from "../../../data/part1/traffic";
import { artQuestions } from "../../../data/part1/art";
import { logisticsQuestions } from "../../../data/part1/logistics";
import { hospitalQuestions } from "../../../data/part1/hospital";
import { sportsQuestions } from "../../../data/part1/location/sports";
import { commercialQuestions } from "../../../data/part1/location/commercial";
import { educationalQuestions } from "../../../data/part1/location/educational";
import { transportationQuestions } from "../../../data/part1/location/transportation";
import { outdoorLocationQuestions } from "../../../data/part1/location/outdoor";
import { medicalLocationQuestions } from "../../../data/part1/location/medical";
import { residentialLocationQuestions } from "../../../data/part1/location/residential";
import { culturalQuestions } from "../../../data/part1/location/cultural";
import { sportsQuestions as locationSportsQuestions } from "../../../data/part1/location/sports";
import Part1Tutorial from "../../tutorials/Part1Tutorial";
import { useAuth } from "../../../contexts/AuthContext";
import { doc, getDoc, setDoc, arrayUnion } from "firebase/firestore";
import { db } from "../../../firebase";
import { freeContent } from "../../../utils/freeContent";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

const Part1_1 = ({ isActive }) => {
  const { currentUser, isSubscribed } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showQuestions, setShowQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(15);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [questionType, setQuestionType] = useState("");
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isStarted, setIsStarted] = useState(false);
  const [studyMode, setStudyMode] = useState("text");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [learningPhase, setLearningPhase] = useState("recognition");
  const [eliminationStep, setEliminationStep] = useState(0);
  const [userThoughts, setUserThoughts] = useState("");
  const [studyPhase, setStudyPhase] = useState("recognition");
  const [userInitialThought, setUserInitialThought] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [originalToShuffled, setOriginalToShuffled] = useState({});
  const [shuffledToOriginal, setShuffledToOriginal] = useState({});
  const [isVocabModalOpen, setIsVocabModalOpen] = useState(false);
  const [accentType, setAccentType] = useState("us");
  const [playbackRate, setPlaybackRate] = useState(1.0);
  const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false);
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [audioProgress, setAudioProgress] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);
  const [isStudyModeModalOpen, setIsStudyModeModalOpen] = useState(false);
  const [selectedStudyMode, setSelectedStudyMode] = useState("all");
  const [showNoWrongQuestionsModal, setShowNoWrongQuestionsModal] =
    useState(false);
  const [completedCategories, setCompletedCategories] = useState({});
  const [showTutorial, setShowTutorial] = useState(false);
  const [showVocabulary, setShowVocabulary] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const navigate = useNavigate();
  const [solvedQuestions, setSolvedQuestions] = useState(new Set());
  const [showVideoModal, setShowVideoModal] = useState(false);

  const categories = [
    {
      id: "vocabulary",
      name: "단어 학습",
      description: "사진 묘사에 필요한 핵심 단어와 표현 학습",
    },
    {
      id: "tutorial",
      name: "문법 학습",
      description: "Part 1 문제에 자주 나오는 문법 학습하기",
    },
    {
      id: "location",
      name: "장소 묘사",
      description: "사무실, 거리, 공원 등의 장소를 묘사하는 문제",
    },
    {
      id: "people",
      name: "사람 묘사",
      description: "인물의 행동, 표정, 자세 등을 묘사하는 문제",
    },
  ];

  const subCategories = {
    construction: {
      title: "건설 및 정비",
      description: "건설 현장과 정비 작업을 하는 사람들의 모습",
      examples: [
        "건설 작업자",
        "안전 장비 착용",
        "건설 장비 조작",
        "자동차 수리",
        "기계 정비",
        "장비 점검",
      ],
    },
    household: {
      title: "가사 활동",
      description: "집안일을 하는 사람들의 모습",
      examples: ["청소", "세탁", "집안 정리"],
    },
    office: {
      title: "사무실",
      description: "사무실에서 일하는 사람들의 모습",
      examples: ["회의", "컴퓨터 작업", "서류 작업"],
    },
    outdoor: {
      title: "야외 활동",
      description: "야외에서의 다양한 활동",
      examples: [
        "공원 산책",
        "하이킹",
        "캠핑",
        "피크닉",
        "정원 가꾸기",
        "야외 운동",
      ],
    },
    shopping: {
      title: "상업공간",
      description: "쇼핑 및 음식점 이용 등",
      examples: ["물건 구매", "상품 구경", "계산"],
    },
    traffic: {
      title: "교통 및 공항",
      description: "교통수단과 공항에서의 사람들의 모습",
      examples: [
        "버스/지하철 탑승",
        "택시 이용",
        "차량 운전",
        "공항 체크인",
        "보안 검색",
        "탑승 대기",
      ],
    },
    art: {
      title: "예술 활동",
      description: "예술 관련 활동을 하는 사람들의 모습",
      examples: ["그림 그리기", "조각 작업", "공연"],
    },
    logistics: {
      title: "물류 및 배송",
      description: "창고와 배송 관련 업무를 하는 사람들의 모습",
      examples: [
        "물품 정리",
        "재고 관리",
        "물류 작업",
        "택배 배달",
        "물품 포장",
        "운송",
      ],
    },
    hospital: {
      title: "병원 및 연구실",
      description: "의료 및 연구 환경에서의 사람들의 모습",
      examples: ["진료", "실험", "의료 처치"],
    },
    loc_workplace: {
      title: "사무실 및 업무 공간",
      description: "사무실, 교육시설, 공장 등 업무 환경",
      examples: [
        "사무실 내부",
        "회의실",
        "작업장",
        "공장 시설",
        "교실",
        "도서관",
        "강당",
        "실험실",
        "교무실",
      ],
    },
    loc_commercial: {
      title: "상업 시설",
      description: "쇼핑몰, 상점, 식당 등의 상업 공간",
      examples: ["쇼핑몰", "마트", "식당", "카페", "상점가"],
    },
    loc_transportation: {
      title: "교통 시설",
      description: "역, 공항, 버스 터미널 등의 교통 시설",
      examples: ["기차역", "공항", "버스 터미널", "지하철역", "주차장"],
    },
    loc_outdoor: {
      title: "야외 공간",
      description: "공원, 광장 등의 야외 시설",
      examples: ["공원", "광장", "놀이터", "정원", "산책로"],
    },
    loc_residential: {
      title: "주거 공간",
      description: "아파트, 주택가 등의 주거 시설",
      examples: ["아파트 단지", "주택가", "아파트 로비", "주차장", "놀이터"],
    },
    loc_sports: {
      title: "문화 스포츠",
      description: "체육관, 경기장 등의 스포츠 시설",
      examples: ["체육관", "수영장", "테니스장", "축구장", "야구장"],
    },
  };

  const currentQuestion = questions[currentQuestionIndex];

  const fetchQuestions = async () => {
    if (!selectedCategory || selectedCategory === "vocabulary") return;

    try {
      let questionsData = [];

      if (selectedCategory === "people") {
        switch (subCategory) {
          case "construction":
            questionsData = constructionQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/construction/construction${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/construction/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/construction/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "office":
            questionsData = professionalQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/professional/professional${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/professional/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/professional/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "household":
            questionsData = dailyQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/daily/daily${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/daily/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/daily/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "outdoor":
            questionsData = outdoorQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/outdoor/outdoor${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/outdoor/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/outdoor/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "shopping":
            questionsData = shoppingQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/shopping/shopping${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/shopping/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/shopping/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "traffic":
            questionsData = trafficQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/traffic/traffic${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/traffic/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/traffic/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "art":
            questionsData = artQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/art/art${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/art/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/art/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "logistics":
            questionsData = logisticsQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/logistics/logistics${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/logistics/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/logistics/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "hospital":
            questionsData = hospitalQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/people/hospital/hospital${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/people/hospital/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/people/hospital/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
        }
      } else if (selectedCategory === "location") {
        switch (subCategory) {
          case "loc_workplace":
            questionsData = workplaceQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/workplace/workplace${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/workplace/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/workplace/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "loc_commercial":
            questionsData = commercialQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/commercial/commercial${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/commercial/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/commercial/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "loc_transportation":
            questionsData = transportationQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/transportation/transportation${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/transportation/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/transportation/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "loc_outdoor":
            questionsData = outdoorLocationQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/outdoor/outdoor${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/outdoor/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/outdoor/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "loc_residential":
            questionsData = residentialLocationQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/residential/residential${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/residential/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/residential/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
          case "loc_sports":
            questionsData = sportsQuestions.map((question) => ({
              ...question,
              imageUrl: `/images/part1/location/sports/sports${question.questionNumber}.png`,
              audioUrls: {
                us: `/audios/part1/location/sports/us/us${question.questionNumber}.mp3`,
                uk: `/audios/part1/location/sports/uk/uk${question.questionNumber}.mp3`,
              },
            }));
            break;
        }
      }

      // 문제 순서를 랜덤하게 섞기
      questionsData = questionsData.sort(() => Math.random() - 0.5);

      setQuestions(questionsData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, [selectedCategory, subCategory]);

  useEffect(() => {
    if (currentQuestion) {
      console.log(
        `현재 문제 번호: ${currentQuestion.questionNumber}, 카테고리: ${selectedCategory}, 서브카테고리: ${subCategory}`
      );
    }
  }, [currentQuestion, selectedCategory, subCategory]);

  useEffect(() => {
    if (currentQuestion) {
      // shuffleChoices(currentQuestion);
    }
  }, [currentQuestion]);

  useEffect(() => {
    let timer;
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
    return () => {
      clearInterval(timer);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlaying(false);
      }
    };
  }, [studyPhase, studyMode]);

  useEffect(() => {
    let timer;
    if (studyMode === "text" && isTimerRunning && timeLeft > 0 && !showResult) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    if (timeLeft === 0) {
      setIsTimerRunning(false);
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [timeLeft, isTimerRunning, studyMode, showResult]);

  useEffect(() => {
    const loadCompletedCategories = async () => {
      if (!currentUser) return;

      try {
        const userRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          const data = userDoc.data();
          setCompletedCategories(data.part1CompletedCategories || {});
        }
      } catch (error) {}
    };

    loadCompletedCategories();
  }, [currentUser]);

  // 컴포넌트 마운트 시 localStorage 확인하여 자동 이동
  useEffect(() => {
    const savedCategory = window.localStorage.getItem("part1SelectedCategory");

    if (savedCategory) {
      window.localStorage.removeItem("part1SelectedCategory");

      if (savedCategory === "vocabulary") {
        setShowVocabulary(true);
      } else if (savedCategory === "tutorial") {
        setShowTutorial(true);
      } else {
        setSelectedCategory(savedCategory);
      }
    }
  }, []);

  const handleMainCategoryClick = (key) => {
    if (key === "tutorial") {
      setShowTutorial(true);
    } else if (key === "vocabulary") {
      setShowVocabulary(true);
    } else {
      setSelectedCategory(key);
    }
  };

  const handleSubCategoryClick = (key) => {
    // 구독자인 경우 모든 컨텐츠에 접근 가능
    if (isActive) {
      setSubCategory(key);
      setShowQuestions(true);
      return;
    }

    // 비구독자인 경우 무료 컨텐츠 체크
    const freeCategories = freeContent.part1[selectedCategory] || [];
    const isFreeContent = freeCategories.includes(key);

    if (!isFreeContent) {
      setShowSubscriptionModal(true);
      return;
    }

    setSubCategory(key);
    setShowQuestions(true);
  };

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch((error) => {});
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
    setTimeLeft(studyMode === "text" ? 15 : 0);
    setIsTimerRunning(studyMode === "text");
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setAudioProgress(audioRef.current.currentTime);
    }
  };

  const handleProgressBarClick = (e) => {
    if (audioRef.current) {
      const progressBar = e.currentTarget;
      const clickPosition =
        (e.clientX - progressBar.getBoundingClientRect().left) /
        progressBar.offsetWidth;
      const newTime = clickPosition * audioDuration;
      audioRef.current.currentTime = newTime;
      setAudioProgress(newTime);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleAudioLoad = () => {
    if (audioRef.current) {
      setAudioDuration(audioRef.current.duration);
      audioRef.current.playbackRate = playbackRate;
    }
  };

  const handleStudyModeChange = (mode) => {
    // 오디오 초기화
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }

    // 문제 상태 초기화
    setShowResult(false);
    setSelectedAnswers([]);
    setTimeLeft(15);
    setIsTimerRunning(mode === "text");
    setStudyPhase("elimination");

    // 학습 모드 변경
    setStudyMode(mode);
  };

  const handlePhaseChange = () => {
    switch (learningPhase) {
      case "recognition":
        setLearningPhase("elimination");
        break;
      case "elimination":
        if (eliminationStep < 3) {
          setEliminationStep((prev) => prev + 1);
        } else {
          setLearningPhase("feedback");
        }
        break;
    }
  };

  const getBackButtonText = () => {
    if (showQuestions && subCategory) {
      return "서브카테고리 선택으로 돌아가기";
    } else if (selectedCategory) {
      return "학습 유형 선택으로 돌아가기";
    }
    return "";
  };

  const handleBackButton = () => {
    if (showQuestions && subCategory) {
      setShowQuestions(false);
      setSubCategory("");
      setCurrentQuestionIndex(0);
      setIsStarted(false);
    } else if (selectedCategory) {
      setSelectedCategory("");
    }
  };

  const handleAccentChange = (accent) => {
    setAccentType(accent);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      // 새로운 accent에 맞는 오디오 소스로 변경
      audioRef.current.src = currentQuestion.audioUrls[accent];
    }
  };

  const handlePlaybackRateChange = (rate) => {
    setPlaybackRate(rate);
    if (audioRef.current) {
      audioRef.current.playbackRate = rate;
    }
  };

  const handleReset = () => {
    // 오디오 초기화
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }

    // 문제 상태 초기화
    setShowResult(false);
    setSelectedAnswers([]);
    setIsTimeUp(false);
  };

  const handleStart = () => {
    setIsStudyModeModalOpen(true);
  };

  const handleStudyModeSelect = async (mode) => {
    setSelectedStudyMode(mode);
    setIsStudyModeModalOpen(false);
    setSolvedQuestions(new Set());

    // 오디오 상태 초기화 추가
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      setAudioProgress(0);
    }

    try {
      if (mode === "wrong" && currentUser) {
        const wrongQuestionsRef = doc(db, "wrongQuestions", currentUser.uid);
        const wrongQuestionsDoc = await getDoc(wrongQuestionsRef);
        const path = `part1/${selectedCategory}/${subCategory}`;
        const wrongNumbers = wrongQuestionsDoc.data()?.[path] || [];

        if (wrongNumbers.length === 0) {
          setShowNoWrongQuestionsModal(true);
          return;
        } else {
          const filteredQuestions = questions.filter((q) =>
            wrongNumbers.includes(q.questionNumber)
          );
          setQuestions(filteredQuestions);
        }
      }

      // 문제 풀이 시작을 위한 상태 설정
      setIsStarted(true);
      setStudyPhase("elimination");
      if (studyMode === "text") {
        setTimeLeft(15);
        setIsTimerRunning(true);
      }
      setShowResult(false);
      setSelectedAnswers([]);
    } catch (error) {}
  };

  const handleShowResult = () => {
    setShowResult(true);
    setSolvedQuestions(
      (prev) => new Set([...prev, currentQuestion.questionNumber])
    );
    const isCorrect = checkAnswers();
    if (!isCorrect && currentUser) {
      saveWrongQuestion(currentQuestion.questionNumber);
    }
  };

  const saveWrongQuestion = async (questionNumber) => {
    if (!currentUser) return;

    try {
      const wrongQuestionsRef = doc(db, "wrongQuestions", currentUser.uid);
      const path = `part1/${selectedCategory}/${subCategory}`;

      await setDoc(
        wrongQuestionsRef,
        {
          [path]: arrayUnion(questionNumber),
        },
        { merge: true }
      );
    } catch (error) {}
  };

  const checkAnswers = () => {
    const isCorrect =
      selectedAnswers.length === currentQuestion.incorrectAnswers.length &&
      selectedAnswers.every((answer) =>
        currentQuestion.incorrectAnswers.includes(answer)
      );

    // 틀린 문제 풀이 모드에서 문제를 맞췄을 경우
    if (isCorrect && selectedStudyMode === "wrong") {
      removeFromWrongQuestions(currentQuestion.questionNumber);
    }

    return isCorrect;
  };

  const removeFromWrongQuestions = async (questionNumber) => {
    if (!currentUser) return;

    try {
      const wrongQuestionsRef = doc(db, "wrongQuestions", currentUser.uid);
      const path = `part1/${selectedCategory}/${subCategory}`;

      // 현재 틀린 문제 목록 가져오기
      const wrongQuestionsDoc = await getDoc(wrongQuestionsRef);
      const currentWrongQuestions = wrongQuestionsDoc.data()?.[path] || [];

      // 맞춘 문제 번호 제거
      const updatedWrongQuestions = currentWrongQuestions.filter(
        (num) => num !== questionNumber
      );

      // 업데이트된 목록 저장
      await setDoc(
        wrongQuestionsRef,
        {
          [path]: updatedWrongQuestions,
        },
        { merge: true }
      );
    } catch (error) {}
  };

  const renderMainCategorySelection = () => {
    return (
      <div className="subcategory-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className="subcategory-card"
            onClick={() => handleMainCategoryClick(category.id)}
          >
            <h3>{category.name}</h3>
            <p>{category.description}</p>
          </div>
        ))}
      </div>
    );
  };

  const renderSubCategorySelection = () => {
    const freeCategories = freeContent.part1[selectedCategory] || [];

    return (
      <div className="subcategory-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 20px",
            marginBottom: "20px",
          }}
        >
          <button
            className="back-button"
            onClick={() => setSelectedCategory("")}
          >
            ← 학습 유형 선택으로 돌아가기
          </button>

          <button
            className="back-button"
            style={{ backgroundColor: "#4a4a7a" }}
            onClick={() => setShowVideoModal(true)}
          >
            설명 동영상 보기
          </button>
        </div>

        <h2>{selectedCategory === "location" ? "장소 묘사" : "사람 묘사"}</h2>
        <div className="subcategory-grid">
          {Object.entries(subCategories)
            .filter(([key]) => {
              if (selectedCategory === "people") {
                return !key.startsWith("loc_");
              } else if (selectedCategory === "location") {
                return key.startsWith("loc_");
              }
              return false;
            })
            .map(([key, category]) => {
              const isFreeContent = freeCategories.includes(key);

              return (
                <div
                  key={key}
                  className="subcategory-card"
                  onClick={() => handleSubCategoryClick(key)}
                >
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                  {completedCategories[key] && (
                    <div className="completion-badge">학습완료</div>
                  )}
                  {!isActive &&
                    !isFreeContent && ( // 구독자 아닐 때 + 유료컨텐츠면 -> 잠금표시
                      <div className="lock-overlay">
                        <img src="/icons/lock.svg" alt="잠김" />
                      </div>
                    )}
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  if (showTutorial) {
    return <Part1Tutorial onBack={() => setShowTutorial(false)} />;
  }

  if (showVocabulary) {
    return <VocabularyStudy onBack={() => setShowVocabulary(false)} />;
  }

  if (!showQuestions) {
    if (selectedCategory === "tutorial") {
      return (
        <div className="part1-container">
          <button className="back-to-main-btn" onClick={handleBackButton}>
            ← 메인 학습 페이지로 돌아가기
          </button>
          <Part1Tutorial />
        </div>
      );
    }

    if (selectedCategory === "vocabulary") {
      return (
        <div className="part1-container">
          <button className="back-to-main-btn" onClick={handleBackButton}>
            ← 메인 학습 페이지로 돌아가기
          </button>
          <VocabularyStudy selectedCategory={selectedCategory} />
        </div>
      );
    }

    if (selectedCategory) {
      return renderSubCategorySelection();
    }

    return (
      <div className="part1-container">
        <h2>TOEIC Part 1 - 사진 묘사</h2>
        <p className="category-instruction">
          학습하고자 하는 유형을 선택하세요
        </p>
        <div className="part1-categories">
          {categories.map((category) => (
            <div
              key={category.id}
              className="category-item hover-effect"
              onClick={() => handleMainCategoryClick(category.id)}
            >
              <h2>{category.name}</h2>
              <p>{category.description}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (loading && selectedCategory) {
    return <div>Loading...</div>;
  }

  if (!currentQuestion) {
    return <div>문제를 불러오는 중...</div>;
  }

  const handleNext = () => {
    const allQuestionsCompleted = solvedQuestions.size === questions.length;

    if (
      currentQuestionIndex === questions.length - 1 &&
      allQuestionsCompleted
    ) {
      handleComplete();
      return;
    }

    setCurrentQuestionIndex((prev) => prev + 1);
    setShowResult(false);
    setSelectedAnswers([]);
    setTimeLeft(studyMode === "text" ? 15 : 0);
    setIsTimerRunning(true);
    setStudyPhase("elimination");
    setIsStarted(true);

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
  };

  const handleAnswer = (key) => {
    if (showResult) return; // 정답이 보여진 후에는 선택 불가

    if (selectedAnswers.includes(key)) {
      // 이미 선택된 답안 취소 가능
      setSelectedAnswers(selectedAnswers.filter((answer) => answer !== key));
    } else {
      // 3개까지만 선택 가능하지만, 이미 3개가 선택된 경우에도 다른 것으로 변경 가능
      if (selectedAnswers.length >= 3) {
        return; // 3개 이상은 추가 선택 불가
      }
      const newSelectedAnswers = [...selectedAnswers, key];
      setSelectedAnswers(newSelectedAnswers);
    }
  };

  const renderQuestion = () => {
    if (!currentQuestion) return null;

    return (
      <div className="question-container">
        <div className="choices-container">
          {Object.entries(currentQuestion.choices).map(([key, value]) => (
            <button
              key={key}
              className={`choice-btn ${
                selectedAnswers.includes(key) ? "selected" : ""
              } ${
                showResult
                  ? currentQuestion.incorrectAnswers.includes(key)
                    ? "correct"
                    : selectedAnswers.includes(key)
                    ? "wrong"
                    : ""
                  : ""
              }`}
              onClick={() => handleAnswer(key)}
              disabled={showResult || (studyMode === "text" && timeLeft === 0)}
            >
              <span>{`${key}. `}</span>
              {studyMode !== "audio" && <span>{value}</span>}
            </button>
          ))}
        </div>

        {studyMode === "text" && (
          <div className={`timer ${timeLeft <= 3 ? "timer-warning" : ""}`}>
            {timeLeft > 0 ? `${timeLeft}초` : "시간 종료"}
          </div>
        )}

        {!showResult && (
          <button className="check-answer-btn" onClick={handleShowResult}>
            정답 보기
          </button>
        )}
      </div>
    );
  };

  const renderPhaseContent = () => {
    if (!studyPhase || !isStarted) {
      return null;
    }

    switch (studyPhase) {
      case "recognition":
        return (
          <div className="recognition-phase">
            <div className="progress-info">
              <span className="question-progress">
                {currentQuestionIndex + 1} / {questions.length}
              </span>
            </div>
            <div className="instruction-text">
              이미지를 보고 상황을 파악해보세요.
            </div>
            <div className="image-container">
              <img
                src={currentQuestion.imageUrl}
                alt="question"
                className="question-image"
              />
            </div>
          </div>
        );

      case "elimination":
        return (
          <>
            <div className="elimination-phase">
              <div className="left-section">
                <div className="progress-info">
                  <span className="question-progress">
                    {currentQuestionIndex + 1} / {questions.length}
                  </span>
                </div>
                <div className="image-container">
                  <img
                    src={currentQuestion.imageUrl}
                    alt="question"
                    className="question-image"
                  />
                </div>
                {(studyMode === "audio" || studyMode === "both") && (
                  <div className="audio-controls">
                    <div className="accent-buttons">
                      <button
                        className={`accent-btn ${
                          accentType === "us" ? "active" : ""
                        }`}
                        onClick={() => handleAccentChange("us")}
                      >
                        미국 발음
                      </button>
                      <button
                        className={`accent-btn ${
                          accentType === "uk" ? "active" : ""
                        }`}
                        onClick={() => handleAccentChange("uk")}
                      >
                        영국 발음
                      </button>
                    </div>
                    <div className="playback-rate-buttons">
                      {[0.8, 1.0, 1.5, 2.0].map((rate) => (
                        <button
                          key={rate}
                          className={`playback-rate-btn ${
                            playbackRate === rate ? "active" : ""
                          }`}
                          onClick={() => handlePlaybackRateChange(rate)}
                        >
                          {rate}x
                        </button>
                      ))}
                    </div>

                    <div className="audio-player">
                      <button
                        className={`audio-btn ${isPlaying ? "playing" : ""}`}
                        onClick={handlePlayPause}
                      >
                        <img
                          src={
                            isPlaying ? "/icons/pause.svg" : "/icons/play.svg"
                          }
                          alt={isPlaying ? "일시정지" : "재생"}
                          className="audio-control-icon"
                          style={{
                            filter: "brightness(0) invert(1)",
                            width: "24px", // 아이콘 크기 지정
                            height: "24px",
                          }}
                        />
                      </button>

                      <div className="progress-container">
                        <div
                          className="progress-bar"
                          onClick={handleProgressBarClick}
                        >
                          <div
                            className="progress-fill"
                            style={{
                              width: `${
                                (audioProgress / audioDuration) * 100
                              }%`,
                            }}
                          />
                        </div>
                        <div className="time-display">
                          <span>{formatTime(audioProgress)}</span>
                          <span>{formatTime(audioDuration)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="right-section">
                <div className="instruction-text">
                  틀린 설명 3개를 골라보세요!
                </div>
                {renderQuestion()}
                <div className="result-buttons">
                  {showResult && (
                    <>
                      <button
                        className="reset-btn"
                        onClick={() => {
                          if (currentQuestionIndex > 0) {
                            setCurrentQuestionIndex((prev) => prev - 1);
                            setShowResult(false);
                            setSelectedAnswers([]);
                            setTimeLeft(studyMode === "text" ? 15 : 0);
                            setIsTimerRunning(true);
                            setStudyPhase("elimination");
                            setIsStarted(true);
                          }
                        }}
                        disabled={currentQuestionIndex === 0}
                      >
                        이전 문제
                      </button>
                      <button className="next-btn" onClick={handleNext}>
                        다음 문제
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            {showResult && (
              <div className="full-width-explanation">
                <div
                  className={`result-message ${
                    checkAnswers() ? "success" : "error"
                  }`}
                >
                  {checkAnswers()
                    ? "정답입니다! 틀린 설명을 모두 찾았습니다!"
                    : `오답입니다. 틀린 설명은 ${currentQuestion.incorrectAnswers.join(
                        ", "
                      )}번입니다.`}
                </div>
                <div className="explanation-box">
                  <h3>문제 해설</h3>
                  <p>{currentQuestion.explanation}</p>
                </div>
              </div>
            )}
          </>
        );

      default:
        return null;
    }
  };

  const handleModalClose = () => {
    setShowCompletionModal(false);
    setShowQuestions(false);
    setSelectedCategory("");
    setCurrentQuestionIndex(0);
    setIsStarted(false);
  };

  const handleComplete = async () => {
    if (!currentUser) return;

    try {
      const updatedCategories = {
        ...completedCategories,
        [subCategory]: true,
      };

      // Firestore에 저장
      const userRef = doc(db, "users", currentUser.uid);
      await setDoc(
        userRef,
        {
          part1CompletedCategories: updatedCategories,
        },
        { merge: true }
      );

      setCompletedCategories(updatedCategories);
      setShowCompletionModal(true);
    } catch (error) {
      console.error("학습 완료 처리 중 오류:", error);
    }
  };

  return (
    <div className="part1-container">
      {currentQuestion && (
        <audio
          ref={audioRef}
          src={currentQuestion.audioUrls[accentType]}
          onEnded={handleAudioEnd}
          onLoadedData={handleAudioLoad}
          onTimeUpdate={handleTimeUpdate}
        />
      )}
      {(selectedCategory || showQuestions) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 20px",
            marginBottom: "20px",
          }}
        >
          <button
            className="back-button"
            onClick={() => setShowQuestions(false)}
          >
            ← 서브카테고리 선택으로 돌아가기
          </button>

          <button
            className="back-button"
            style={{ backgroundColor: "#4a4a7a" }}
            onClick={() => setShowVideoModal(true)}
          >
            설명 동영상 보기
          </button>
        </div>
      )}

      {selectedCategory && subCategory && (
        <div className="study-options">
          <div className="study-options-header">
            <span className="study-options-title">학습 단계</span>
          </div>
          <div className="study-options-buttons">
            <button
              className={`option-btn ${studyMode === "text" ? "active" : ""}`}
              onClick={() => handleStudyModeChange("text")}
            >
              1단계: 텍스트만
            </button>
            <span className="arrow-icon">→</span>
            <button
              className={`option-btn ${studyMode === "both" ? "active" : ""}`}
              onClick={() => handleStudyModeChange("both")}
            >
              2단계: 텍스트+오디오
            </button>
            <span className="arrow-icon">→</span>
            <button
              className={`option-btn ${studyMode === "audio" ? "active" : ""}`}
              onClick={() => handleStudyModeChange("audio")}
            >
              3단계: 오디오만
            </button>
          </div>
          <div className="study-mode-description">
            {studyMode === "text" && (
              <p>
                기본적인 짧은 문장 훈련과 오답 패턴을 학습하는 단계입니다.
                텍스트만 보고 15초 안에 문제를 풀어보세요. 단, 틀린 것 3개를
                고르는 것입니다. 포인트는 왜 오답인지를 아는 것과 짧은 문장을
                빨리 이해할 수 있느냐 입니다. .실전에서는 맞는걸 골라야 합니다.
                그러나 훈련부터 틀린것을 없애는 소거법으로 풀도록 훈련합니다.
                맞는걸 고르려고 하면 더 어렵습니다. 토익에선 어느정도 확실한
                오답을 보기에 배치하기에 아닌걸 고르는 훈련을 미리 하고 실제
                시험보실땐 틀린걸 제거하고 남은걸 마킹하세요
              </p>
            )}
            {studyMode === "both" && (
              <p>
                이제부턴 텍스트가 실제로 어떻게 들리는지 확인해보세요. 미국
                발음과 영국 발음을 비교해보며 내가 예상한 발음이 어떻게 다르게
                들리는지 비교해봅니다.실전에서는 맞는걸 골라야 합니다. 그러나
                훈련부터 틀린것을 없애는 소거법으로 풀도록 훈련합니다. 맞는걸
                고르려고 하면 더 어렵습니다. 토익에선 어느정도 확실한 오답을
                보기에 배치하기에 아닌걸 고르는 훈련을 미리 하고 실제 시험보실땐
                틀린걸 제거하고 남은걸 마킹하세요
              </p>
            )}
            {studyMode === "audio" && (
              <p>
                오디오만 듣고 문제를 풀어보세요. 실전 토익 시험과 동일한
                환경입니다. 이번엔 텍스트 도움 없이 오디오만 들으면서 안 들리는
                부분이 어딘지를 체크해보세요. 이때 내가 텍스트에서 보고 이해한
                것이 들어서도 이해가 되면 성공입니다. .실전에서는 맞는걸 골라야
                합니다. 그러나 훈련부터 틀린것을 없애는 소거법으로 풀도록
                훈련합니다. 맞는걸 고르려고 하면 더 어렵습니다. 토익에선
                어느정도 확실한 오답을 보기에 배치하기에 아닌걸 고르는 훈련을
                미리 하고 실제 시험보실땐 틀린걸 제거하고 남은걸 마킹하세요
              </p>
            )}
          </div>
        </div>
      )}

      {selectedCategory && !subCategory ? (
        renderSubCategorySelection()
      ) : (
        <div className="part1-question-content">
          {!isStarted ? (
            <>
              <h2>Part 1 - {subCategories[subCategory]?.title}</h2>
              <button className="next-btn" onClick={handleStart}>
                Start Question
              </button>
            </>
          ) : (
            <>{renderPhaseContent()}</>
          )}
        </div>
      )}

      {/* 틀린 문제 없음 알림 모달 */}
      <Modal
        isOpen={showNoWrongQuestionsModal}
        onRequestClose={() => setShowNoWrongQuestionsModal(false)}
        className="no-wrong-questions-modal"
        overlayClassName="no-wrong-questions-overlay"
      >
        <div className="text-center p-8">
          <h2 className="text-2xl font-bold mb-4">📚 알림</h2>
          <p className="text-gray-600 mb-6">
            현재 틀린 문제가 없습니다!
            <br />
            전체 문제 풀이를 진행해주세요.
          </p>
          <button
            onClick={() => setShowNoWrongQuestionsModal(false)}
            className="modal-button"
          >
            확인
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={showCompletionModal}
        onRequestClose={() => setShowCompletionModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <div className="text-center p-8">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold mb-4">축하합니다!</h2>
          <p className="text-gray-600 mb-6">모든 문제를 완료하셨습니다!</p>
          <button
            onClick={handleModalClose}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
          >
            학습 유형 선택하기
          </button>
        </div>
      </Modal>

      {/* 학습 모드 선택 모달 추가 */}
      <Modal
        isOpen={isStudyModeModalOpen}
        onRequestClose={() => setIsStudyModeModalOpen(false)}
        className="study-mode-modal-content"
        overlayClassName="study-mode-modal-overlay"
      >
        <div className="study-mode-modal-header">
          <h3>학습 모드 선택</h3>
          <button
            className="modal-close-btn"
            onClick={() => setIsStudyModeModalOpen(false)}
          >
            ✕
          </button>
        </div>
        <div className="study-mode-options">
          <button
            className="study-mode-button all"
            onClick={() => handleStudyModeSelect("all")}
          >
            전체 문제 풀기
          </button>
          <button
            className="study-mode-button wrong"
            onClick={() => handleStudyModeSelect("wrong")}
            disabled={!currentUser}
          >
            틀린 문제만 풀기
            {!currentUser && (
              <span className="login-required">(로그인 필요)</span>
            )}
          </button>
        </div>
      </Modal>

      {showVideoModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
          onClick={() => setShowVideoModal(false)}
        >
          <div
            style={{
              background: "#222",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "800px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={() => setShowVideoModal(false)}
            >
              ×
            </button>
            <video
              src="/videos/part1-explanation.mp4"
              controls
              autoPlay
              style={{ width: "100%", marginTop: "20px" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Part1_1;
